import './styles/style.scss';
import MainNav from './MainNav';

export default MainNav;



// WEBPACK FOOTER //
// ./src/components/MainNav/index.js